import { render, staticRenderFns } from "./CheckboxChannels.vue?vue&type=template&id=a2a175e2"
import script from "./CheckboxChannels.vue?vue&type=script&lang=js"
export * from "./CheckboxChannels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports